module.exports = __webpack_public_path__ + "static/jam-approval-853bd78b3b275c8d75d8fe8626454fbb.png";